
import Request from './request';

export default class Issues extends Request {

    query( after, search ) {
        return `query {
            repository(owner: "${ this.user }", name: "${ this.repo }") {
                name
                description
                issues(first: ${ this.pagesize }, ${ after ? `after: "${ after }",` : '' } orderBy: { field: ${ this.order }, direction: DESC }${ search ? `, labels: ["${ search }"]` : '' }) {
                    totalCount
                    pageInfo {
                        hasPreviousPage
                        startCursor
                        hasNextPage
                        endCursor
                    }
                    edges {
                        node {
                            title
                            number
                            createdAt
                            author {
                                login
                            }
                            labels(first: 10) {
                                edges {
                                    node {
                                        name
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }`;
    }
}